import script from "./BottomNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./BottomNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./BottomNavigation.vue?vue&type=style&index=0&id=655d3ff6&lang=css"

const __exports__ = script;

export default __exports__